// extracted by mini-css-extract-plugin
module.exports = {"tableOverflow":"Table_tableOverflow__vdMZQ","centered":"Table_centered__3l6kB","tablePaginator":"Table_tablePaginator__2wzC7"};